import CONSTANTS from './constants';

const integer = () => value =>
  value && !Number.isInteger(value)
    ? CONSTANTS.LABELS.ERROR_NOT_INTEGER
    : undefined;

export default integer;
